"use strict";
var GpmlUtilities = require("./gpml-utilities");
exports.SHAPE_DEFAULTS = {
    attributes: {
        Align: {
            name: 'Align',
            value: 'Center'
        },
        Color: {
            name: 'Color',
            value: '000000'
        },
        FillColor: {
            name: 'FillColor',
            value: 'Transparent'
        },
        FontSize: {
            name: 'FontSize',
            value: 10
        },
        LineThickness: {
            name: 'LineThickness',
            value: 1
        },
        Padding: {
            name: 'Padding',
            value: '0.5em'
        },
        ShapeType: {
            name: 'ShapeType',
            value: 'Rectangle'
        },
        Valign: {
            name: 'Valign',
            value: 'Top'
        },
        ZOrder: {
            name: 'ZOrder',
            value: 0
        },
    }
};
function applyDefaults(gpmlElement, defaults) {
    gpmlElement = GpmlUtilities.applyDefaults(gpmlElement, [exports.SHAPE_DEFAULTS, defaults]);
    return gpmlElement;
}
exports.applyDefaults = applyDefaults;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhcGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvc2hhcGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLGdEQUFrRDtBQUV2QyxRQUFBLGNBQWMsR0FBRztJQUMzQixVQUFVLEVBQUU7UUFDWCxLQUFLLEVBQUU7WUFDTixJQUFJLEVBQUUsT0FBTztZQUNiLEtBQUssRUFBRSxRQUFRO1NBQ2Y7UUFDRCxLQUFLLEVBQUU7WUFDTixJQUFJLEVBQUUsT0FBTztZQUNiLEtBQUssRUFBRSxRQUFRO1NBQ2Y7UUFDRCxTQUFTLEVBQUU7WUFDVixJQUFJLEVBQUUsV0FBVztZQUNqQixLQUFLLEVBQUUsYUFBYTtTQUNwQjtRQUNELFFBQVEsRUFBRTtZQUNULElBQUksRUFBQyxVQUFVO1lBQ2YsS0FBSyxFQUFDLEVBQUU7U0FDUjtRQUNELGFBQWEsRUFBRTtZQUNkLElBQUksRUFBRSxlQUFlO1lBQ3JCLEtBQUssRUFBRSxDQUFDO1NBQ1I7UUFDRCxPQUFPLEVBQUU7WUFDUixJQUFJLEVBQUUsU0FBUztZQUNmLEtBQUssRUFBRSxPQUFPO1NBQ2Q7UUFDRCxTQUFTLEVBQUU7WUFDVixJQUFJLEVBQUUsV0FBVztZQUNqQixLQUFLLEVBQUUsV0FBVztTQUNsQjtRQUNELE1BQU0sRUFBRTtZQUNQLElBQUksRUFBRSxRQUFRO1lBQ2QsS0FBSyxFQUFFLEtBQUs7U0FDWjtRQUNELE1BQU0sRUFBRTtZQUNQLElBQUksRUFBRSxRQUFRO1lBQ2QsS0FBSyxFQUFFLENBQUM7U0FDUjtLQUNEO0NBQ0QsQ0FBQztBQUVGLHVCQUE4QixXQUFXLEVBQUUsUUFBUTtJQUNsRCxXQUFXLEdBQUcsYUFBYSxDQUFDLGFBQWEsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxzQkFBYyxFQUFFLFFBQVEsQ0FBQyxDQUFDLENBQUM7SUFDbkYsTUFBTSxDQUFDLFdBQVcsQ0FBQztBQUNwQixDQUFDO0FBSEQsc0NBR0M7QUFBQSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/shape.js
// module id = 712
// module chunks = 0